export const SUBTESTS_EXCLUDED_FROM_OVERALL_ARC_BY_PROGRAM: Record<
  string,
  string[]
> = {
  EACT: ["Science", "Writing"]
}
